//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionSend(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M23.6302 12L0.970215 1.27L2.60021 10.51L9.00021 13.52V11.31L4.39021 9.14L3.61021 4.73L18.9602 12L3.61021 19.27L4.60021 13.66L2.72021 12.78L0.970215 22.73L23.6302 12Z" fill="currentColor" /></svg>;
}
export default IconActionSend;